import axios from 'axios'

// 创建axios实例
const service = axios.create({
    baseURL: 'https://www.kinats.com/kcloud/public/weiapi/v1', // api的base_url
    //baseURL: 'http://127.0.0.1:8000/weiapi/v1', // api的base_url
    timeout: 5000 // 请求超时时间
        // headers: {
        //   'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
        // }
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code) {
            // console.log('网络错误~')
            return
        }
        return response.data.data
    }, error => {

        return Promise.reject('网络错误，请稍后重试。')
    }
)

export default service